import { useEffect, useState } from 'react';
import styles from '../../styles/components/input-container.module.scss';
import { useTranslations } from 'next-intl';

const SelectAndLabel = (props) => {
  const t = useTranslations('components');
  const [classes, setClasses] = useState(
    props.className
      ? styles.inputContainer + ' ' + props.className
      : styles.inputContainer
  );
  const [value, setValue] = useState(null);

  const handleFieldChange = (event) => {
    setValue(event.target.value);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  useEffect(() => {
    if (props.className) {
      setClasses(styles.inputContainer + ' ' + props.className);
    }
  }, [props.className]);

  useEffect(() => {
    if (props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  return (
    <div className={classes}>
      {props.label && (
        <label className={props.showRequiredMark ? 'required' : null}>
          {props.label}
        </label>
      )}

      {props.disabled && <p>{value}</p>}

      {props.description && <p>{props.description}</p>}

      {!props.disabled && (
        <select
          name={props.name}
          aria-label={props.label}
          value={value ?? 'DEFAULT'}
          id={props.name}
          onChange={(e) => handleFieldChange(e)}
          disabled={props.disable !== null ? props.disable : false}
        >
          <option value="DEFAULT" disabled>
            {t('seleccionar')}
          </option>
          {props.options?.map((option, key) => {
            return (
              <option
                aria-label={option.name}
                key={key}
                value={option.value ?? option.name}
              >
                {option.name}
              </option>
            );
          })}
        </select>
      )}
    </div>
  );
};

export default SelectAndLabel;
